<template>
  <div
    ref="colorPicker"
    class="ts-quill-color-picker"
    @mouseover="handleMouseEnter"
    @mouseout="handleMouseOut"
  >
    <ASvg
      class="anchor"
      :fontColor="activeFontColor"
      :bgColor="activeBgColor"
    />
    <img
      class="anchor-icon"
      :class="{ expand: boardShow }"
      src="../quill/asstes/arrow-v.svg"
    />
    <div
      ref="palette"
      class="ts-quill-colot-palette"
      :class="{ top: isBeyondBottom }"
      v-show="boardShow"
    >
      <p class="title">字体颜色</p>
      <ul class="font-colors">
        <li
          :class="{ active: fontColor?.toLocaleUpperCase() === item }"
          v-for="item in FONT_COLOR_CODE"
          :key="item"
          @click="fontColorPick(item)"
        >
          <ASvg :fontColor="item"></ASvg>
        </li>
      </ul>
      <p class="title">背景颜色</p>
      <ul class="bg-colors">
        <li
          v-for="item in BG_COLOR_CODE"
          :key="item"
          :class="{
            empty: item === '',
            active: bgColor?.toLocaleUpperCase() === item,
          }"
          :style="`background: ${item}`"
          @click="bgColorPick(item)"
        ></li>
      </ul>
      <button @click="reset">恢复默认</button>
    </div>
  </div>
</template>

<script>
import { FONT_COLOR_CODE, BG_COLOR_CODE, FONT_DEF_COLOR } from '../const.js';
import ASvg from './ASvg.vue';

// 这个值指弹层的高度，相对固定
const PALETTE_HEIGHT = 175;

export default {
  components: { ASvg },
  props: {
    fontColor: {
      type: String,
    },
    bgColor: {
      type: String,
    },
  },
  watch: {
    fontColor() {
      this.activeFontColor = this.fontColor;
    },
    bgColor() {
      this.activeBgColor = this.bgColor;
    },
  },
  data() {
    return {
      FONT_COLOR_CODE,
      BG_COLOR_CODE,
      activeFontColor: FONT_DEF_COLOR,
      activeBgColor: '',
      boardShow: false,
      // 弹层是否超出下边界
      isBeyondBottom: false,
    };
  },
  methods: {
    fontColorPick(color) {
      this.activeFontColor = color;
      this.$emit('fontColorChange', color);
      this.boardShow = false;
    },
    bgColorPick(color) {
      this.activeBgColor = color;
      this.$emit('bgColorChange', color);
      this.boardShow = false;
    },
    reset() {
      this.$emit('reset');
      this.activeFontColor = FONT_DEF_COLOR;
      this.activeBgColor = '';
      this.boardShow = false;
    },
    modifyPosition() {
      const colorPicker = this.$refs.colorPicker;
      if (colorPicker) {
        const bodyH = document.body.getBoundingClientRect()?.height;
        const colorPickerBottom = colorPicker.getBoundingClientRect().bottom;
        // 超出下边界
        if (colorPickerBottom + PALETTE_HEIGHT > bodyH) {
          this.isBeyondBottom = true;
        } else {
          this.isBeyondBottom = false;
        }
      }
    },
    handleMouseEnter() {
      this.modifyPosition();
      this.boardShow = true;
    },
    handleMouseOut() {
      this.boardShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ts-quill-color-picker {
  display: inline-flex;
  position: relative;

  .anchor-icon {
    width: 18px;
    height: 22px;
    cursor: pointer;
    margin-right: -2px;
    transition: all 0.2s ease-in-out;
    &.expand {
      transform: rotate(-180deg) translateY(-2px);
    }
  }
  .ts-quill-colot-palette {
    $wrapperH: 32px;
    font-size: 12px;
    position: absolute;
    top: $wrapperH;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 5px 9px 0px #d5e3df;
    border-radius: 12px;
    border: 1px solid #eaeaea;
    // 热区
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      transform: translateY(-100%);
      height: 10px;
    }
    &.top {
      top: unset;
      bottom: $wrapperH;
      &::before {
        top: unset;
        bottom: 0;
        transform: translateY(100%);
      }
    }
    .title {
      color: #484848;
      margin-bottom: 10px;
      text-align: left;
    }
    > ul {
      width: 194px;
      margin-top: 2px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      > li {
        width: 22px;
        height: 22px;
        border-radius: 4px;
        margin-right: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          border: 1.5px solid #14bb8c !important;
        }
        &:last-child {
          margin-right: 0;
        }
        &.empty {
          position: relative;
          border-radius: 2px;
          border: 1px solid #d8d8d8;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            width: 110%;
            height: 1px;
            background: #d8d8d8;
          }
        }
      }
      &.font-colors {
        li {
          border-radius: 2px;
          border: 1px solid #d8d8d8;
        }
      }
    }
    > button {
      width: 100%;
      height: 24px;
      line-height: 24px;
      padding: 0;
      border-radius: 4px;
      border: 1px solid #bbbbbb;
      color: #bbbbbb;
      background: none;
      &:hover {
        background: #F2FFFB;
        color: #14BB8C;
        border-color: #14BB8C;
      }
    }
  }
}
</style>
